// React
import { useContext, useEffect, useState } from "react";

// @mui material components
import { Card, Collapse, Icon, Menu, MenuItem, Select, Skeleton, Tooltip } from "@mui/material";

import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import ModalConfirm from "components/Modals/ConfirmMsg";
import ModalOptions from "components/Modals/Options";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import CustomPagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import { MessageManager } from "context";
import { getUproColor } from "utils/colors";
import ModalAjuste from "./components/ModalAjustes";
import ModalAjusteHistory from "./components/ModalAjustes/ModalHistorial";
import ModalProducto from "./components/ModalProducto";
import ModalProductoMovimientos from "./components/ModalProductoMovimientos";
import ModalProductoStock from "./components/ModalProductoStock";
import DrawerProductoDetalle from "layouts/materiaPrima/components/DrawerProductoDetalle";

//REMITO SEDE

import { MenuContext } from "context/menuContext";
import { UserContext } from "context/user";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import ModalStockRapido from "./components/ModalStockRapido";
import productoData from "./data/productoData";
import ModalNuevoRemito from "./components/ModalIngresar/ModalNuevoRemito";
import ModalIngresar from "./components/ModalIngresar";
import ModalProveedores from "./components/ModalProveedores";
function StockPlatos() {
  const { columns, getRows } = productoData;
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [openFilters, setOpenFilters] = useState(false);
  const [page, setPage] = useState(1);
  const [pagesInfo, setPagesInfo] = useState({
    pages: 0,
    total: 0,
  });
  const [orderBy, setOrderBy] = useState({
    campo: "id",
    orden: "DESC",
  });
  const [filter, setFilter] = useState({
    disabled: false,
    tipo: "Plato"
  });
  const [selectedSucursal, setSelectedSucursal] = useState(null);
  const openMenu = false;
  const [openDetailDrawer, setOpenDetailDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState();
  const { handleSnackbar } = useContext(MessageManager);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [openModalProducto, setOpenModalProducto] = useState(false);
  const [openIngresoMenu, setOpenIngresoMenu] = useState(false);
  const [openModalNuevoRemito, setOpenModalNuevoRemito] = useState(false);
  const [openModalIngresar, setOpenModalIngresar] = useState(false);
  const [openModalProductoMovimientos, setOpenModalProductoMovimientos] = useState(false);
  const [openModalProductoStock, setOpenModalProductoStock] = useState(false);
  const [openModalAjuste, setOpenModalAjuste] = useState(false);
  const [selectedAjuste, setSelectedAjuste] = useState();
  const [openAddMenu, setOpenAddMenu] = useState(false);
  const [openAjusteMenu, setOpenAjusteMenu] = useState(false);
  const [openSucursalMenu, setOpenSucursalMenu] = useState(false);
  const [openModalProveedores, setOpenModalProveedores] = useState(false);

  const [openModalAjusteHistory, setOpenModalAjusteHistory] = useState(false);
  const [openModalOptions, setOpenModalOptions] = useState(false);
  const { user } = useContext(UserContext);
  const [openModalStockRapido, setOpenModalStockRapido] = useState(false);
  const { menu } = useContext(MenuContext);

  const { data: dataSucurales, loading: loadingSucursales } = useQuery(
    gql`
      query getSucursales($filter: JSON) {
        sucursales(filter: $filter) {
          id
          nombre
          sede {
            id
            nombre
          }
          administraStock
          principal
        }
      }
    `,
    {
      variables: {
        filter: {
          administraStock: true,
          id: user?.sucursales ? user?.sucursales.map((sucursal) => sucursal.id) : undefined,
        },
      },
      onCompleted: (data) => {
        if (data?.sucursales?.length > 0) {
          setSelectedSucursal(data?.sucursales[0].id);
        }
      },
    }
  );

  const { data: dataCategorias } = useQuery(
    gql`
      query categoriasMateriaPrima {
        categoriasMateriaPrima {
          tipoProducto
          nombre
        }
      }
    `
  );

  const { loading, data, refetch } = useQuery(
    gql`
      query getProductos(
        $search: String
        $page: Int
        $order: Order
        $filter: JSON
        $idSucursal: ID
      ) {
        paginationInfo {
          pages
          total
        }
        materiasPrimas(
          search: $search
          pagination: { page: $page, limit: 10 }
          order: $order
          filter: $filter
        ) {
          id
          codigo
          tipo
          nombre
          disabled
          categoria
          motivoBaja
          porcentajeUtilizable
          tipoUnidad {
            id
            nombre
            abreviatura
            multiplicador
          }
          stock(idSucursal: $idSucursal) {
            cantidad
            enPrestamo
            pasillo
            fila
            columna
            stockMinimo
          }
        }
      }
    `,
    {
      variables: {
        search: search || null,
        page: page,
        order: { field: orderBy.campo, order: orderBy.orden },
        filter: {
          ...filter,
          tipo: filter.tipo === "Todo" ? ["Plato", "Plato_Ingrediente"] : filter.tipo
        },
        idSucursal: selectedSucursal || null,
      },
      fetchPolicy: "no-cache",
    }
  );

  const [getProductosData] = useLazyQuery(
    gql`
      query getProductos($order: Order, $filter: JSON, $idSucursal: ID) {
        materiasPrimas(order: $order, filter: $filter) {
          __typename @skip(if: true)
          id
          tipo
          nombre
          disabled
          categoria
          stock(idSucursal: $idSucursal) {
            cantidad
            enPrestamo
            pasillo
            fila
            columna
            stockMinimo
          }
        }
      }
    `
  );

  const [mutateProducto] = useMutation(gql`
    mutation saveMateriaPrima($input: MateriaPrimaInput!) {
      saveMateriaPrima(input: $input) {
        id
      }
    }
  `);

  const handleSearch = (event) => {
    const newTimeout = setTimeout(() => {
      setSearch(event.target.value);
      setPage(1);
    }, 500);
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    setSearchTimeout(newTimeout);
  };

  const handleOpenMenu = (event, item) => {
    setSelectedItem(item);
    setOpenDetailDrawer(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenDetailDrawer(false);
  };

  const handleOpenProductoModal = () => {
    setOpenDetailDrawer(false);
    setOpenModalProducto(true);
  };

  const handleOrderBy = (campo) => {
    if (orderBy.campo === campo) {
      if (orderBy.orden === "ASC") {
        setOrderBy({
          campo: campo,
          orden: "DESC",
        });
      } else {
        setOrderBy({
          campo: campo,
          orden: "ASC",
        });
      }
    } else {
      setOrderBy({
        campo: campo,
        orden: "ASC",
      });
    }
  };

  const handleOpenAddMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenAddMenu(true);
  };

  const handleCloseAddMenu = () => {
    setAnchorEl(null);
    setOpenAddMenu(false);
  };

  const handleOpenAjusteMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenAjusteMenu(true);
  };

  const handleCloseAjusteMenu = () => {
    setAnchorEl(null);
    setOpenAjusteMenu(false);
  };

  const handleOpenSucursalMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenSucursalMenu(true);
  };

  const handleCloseSucursalMenu = () => {
    setAnchorEl(null);
    setOpenSucursalMenu(false);
  };

  const handleOpenModalConfirm = () => {
    setOpenDetailDrawer(false);
    setOpenModalConfirm(true);
  };

  const handleCloseModalConfirm = () => {
    setOpenModalConfirm(false);
  };

  const handleOpenIngresoMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenIngresoMenu(true);
  };

  const handleCloseIngresoMenu = () => {
    setAnchorEl(null);
    setOpenIngresoMenu(false);
  };

  const handleDisabled = (motivo) => {
    mutateProducto({
      variables: {
        input: {
          id: selectedItem.id,
          disabled: !selectedItem.disabled,
          motivoBaja: motivo || null,
        },
      },
    })
      .then(() => {
        handleSnackbar("Producto actualizado correctamente", "success");
        refetch();
      })
      .catch(() => {
        handleSnackbar("Ocurrió un error al actualizar la materia prima", "error");
      });
    handleCloseMenu();
  };

  useEffect(() => {
    if (data) {
      setRows(getRows(data?.materiasPrimas, handleOpenMenu));
      setPagesInfo(data?.paginationInfo);
    }
  }, [data]);

  const handleFilter = (event) => {
    const { value } = event.target;
    setFilter(prev => ({
      ...prev,
      [event.target.name]: value
    }));
  };

  const renderSucursalMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(openSucursalMenu)}
      onClose={handleCloseSucursalMenu}
      transformOrigin={{ horizontal: "left", vertical: "top" }}
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
        },
      }}
    >
      {dataSucurales?.sucursales?.map((sucursal, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            setSelectedSucursal(sucursal.id);
            handleCloseSucursalMenu();
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <SoftBox mr={2}>
              <SoftTypography variant="p" fontWeight="medium">
                {sucursal.sede.nombre}
              </SoftTypography>
              <SoftTypography variant="p">{` - ${sucursal.nombre}`}</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Icon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                  color:
                    sucursal.id === selectedSucursal
                      ? getUproColor("uproPink")
                      : getUproColor("uproGreen"),
                }}
              >
                location_on
              </Icon>
            </SoftBox>
          </SoftBox>
        </MenuItem>
      ))}
    </Menu>
  );

  const renderAjusteMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(openAjusteMenu)}
      onClose={handleCloseAjusteMenu}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
        },
      }}
    >
      <MenuItem
        onClick={() => {
          setOpenModalAjuste(true);
          setSelectedAjuste("Ajuste");
          handleCloseAjusteMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Ajuste</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproGreen"),
              }}
            >
              drive_file_rename_outline
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setOpenModalAjuste(true);
          setSelectedAjuste("Merma");
          handleCloseAjusteMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Merma</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproPink"),
              }}
            >
              arrow_downward
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setOpenModalAjusteHistory(true);
          handleCloseAjusteMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Ver historial</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproBlue"),
              }}
            >
              history
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
    </Menu>
  );

  const renderAddMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(openAddMenu)}
      onClose={handleCloseAddMenu}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
        },
      }}
    >
      <Tooltip title="Elementos básicos de bajo valor patrimonial" placement="left">
        <MenuItem
          onClick={() => {
            setOpenModalProducto(true);
            setSelectedItem({ tipo: "Material" });
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <SoftBox>
              <SoftTypography variant="p">Material</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Icon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                  color: getUproColor("uproYellow"),
                }}
              >
                category
              </Icon>
            </SoftBox>
          </SoftBox>
        </MenuItem>
      </Tooltip>
      <Tooltip title="Elementos que se agotan con el uso" placement="left">
        <MenuItem
          onClick={() => {
            setOpenModalProducto(true);
            setSelectedItem({ tipo: "Consumible" });
          }}
          sx={{
            minWidth: { xs: "75vw", sm: "auto" },
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <SoftBox>
              <SoftTypography variant="p">Consumible</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Icon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                  color: getUproColor("uproGreen"),
                }}
              >
                recycling
              </Icon>
            </SoftBox>
          </SoftBox>
        </MenuItem>
      </Tooltip>
      <Tooltip
        title="Productos valiosos y específicos que requieren cuidado o mantenimiento"
        placement="left"
      >
        <MenuItem
          onClick={() => {
            setOpenModalProducto(true);
            setSelectedItem({ tipo: "Recurso" });
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <SoftBox>
              <SoftTypography variant="p">Recurso</SoftTypography>
            </SoftBox>
            <SoftBox>
              <Icon
                fontSize="small"
                sx={{
                  verticalAlign: "middle",
                  color: getUproColor("uproPink"),
                }}
              >
                layers
              </Icon>
            </SoftBox>
          </SoftBox>
        </MenuItem>
      </Tooltip>
    </Menu>
  );

  const renderMenu = (
    <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(openMenu)} onClose={handleCloseMenu}>
      {/* <MenuItem onClick={() => setOpenModalProducto(true)} disabled={false}>
        <Icon
          sx={{
            color: getUproColor("uproYellow"),
          }}
          fontSize="small"
        >
          edit
        </Icon>
        &nbsp;Editar
      </MenuItem> */}
      <MenuItem onClick={() => setOpenModalProductoMovimientos(true)} disabled={false}>
        <Icon
          sx={{
            color: getUproColor("uproBlue"),
          }}
          fontSize="small"
        >
          history
        </Icon>
        &nbsp;Últimos movimientos
      </MenuItem>
      {/* <MenuItem onClick={() => setOpenModalProductoStock(true)} disabled={false}>
        <Icon
          sx={{
            color: getUproColor("uproGreen"),
          }}
          fontSize="small"
        >
          inventory
        </Icon>
        &nbsp;Stock en sucursales
      </MenuItem> */}
      {/* <MenuItem onClick={handleOpenModalConfirm} disabled={false}>
        <Icon color={selectedItem?.disabled ? "success" : "error"} fontSize="small">
          {selectedItem?.disabled ? "arrow_upward_icon" : "arrow_downward_icon"}
        </Icon>
        &nbsp;{selectedItem?.disabled ? "Habilitar" : "Deshabilitar"}
      </MenuItem> */}
    </Menu>
  );

  const renderIngresoMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      open={Boolean(openIngresoMenu)}
      onClose={handleCloseIngresoMenu}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
        },
      }}
    >
      <MenuItem
        onClick={() => {
          setOpenModalNuevoRemito(true);
          handleCloseIngresoMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox mr={2}>
            <SoftTypography variant="p">Nuevo remito a proveedor</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproGreen"),
              }}
            >
              add
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setOpenModalIngresar(true);
          handleCloseIngresoMenu();
        }}
        sx={{
          minWidth: { xs: "75vw", sm: "auto" },
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox mr={2}>
            <SoftTypography variant="p">Ver remitos a proveedores</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproBlue"),
              }}
            >
              history
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
    </Menu>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display={{ xs: "flex-row", sm: "flex" }}
              justifyContent="space-between"
              alignItems="center"
              p={3}
              pb={{
                xs: 2,
                sm: 3,
              }}
            >
              <SoftBox pb={{ xs: 3, sm: 0 }} display="flex" justifyContent="space-between">
                <SoftBox
                  display="flex"
                  alignItems="center"
                  onClick={handleOpenSucursalMenu}
                  mr={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <Icon color="primary">location_on</Icon>
                  <SoftTypography
                    variant="h6"
                    sx={{
                      cursor: "pointer",
                    }}
                    ml={1}
                  >
                    {loadingSucursales ? (
                      <Skeleton width={100} />
                    ) : dataSucurales?.sucursales?.find(
                      (sucursal) => sucursal.id === selectedSucursal
                    ) ? (
                      `${dataSucurales?.sucursales?.find(
                        (sucursal) => sucursal.id === selectedSucursal
                      )?.sede.nombre
                        } - ${dataSucurales?.sucursales?.find(
                          (sucursal) => sucursal.id === selectedSucursal
                        )?.nombre
                        }`.length > 30 ? (
                        `${dataSucurales?.sucursales?.find(
                          (sucursal) => sucursal.id === selectedSucursal
                        )?.sede.nombre
                          } - ${dataSucurales?.sucursales?.find(
                            (sucursal) => sucursal.id === selectedSucursal
                          )?.nombre
                          }`.substring(0, 25) + "..."
                      ) : (
                        `${dataSucurales?.sucursales?.find(
                          (sucursal) => sucursal.id === selectedSucursal
                        )?.sede.nombre
                        } - ${dataSucurales?.sucursales?.find(
                          (sucursal) => sucursal.id === selectedSucursal
                        )?.nombre
                        }`
                      )
                    ) : (
                      "No está asignado a ningún pañol"
                    )}
                  </SoftTypography>
                  <Icon color="dark">{openSucursalMenu ? "arrow_drop_up" : "arrow_drop_down"}</Icon>
                </SoftBox>
              </SoftBox>
              <SoftBox
                display={{ xs: "flex-row", sm: "flex" }}
                justifyContent="end"
                alignItems="flex-end"
              >
                <SoftBox
                  sx={{
                    width: { xs: "100%", sm: "auto" },
                    minWidth: 200,
                    mr: 2,
                  }}
                >
                  <Select
                    name="tipo"
                    onChange={handleFilter}
                    value={filter.tipo}
                    fullWidth
                    size="small"
                  >
                    <MenuItem value="Plato">
                      <SoftBox display="flex" alignItems="center" gap={1}>
                        <Icon fontSize="small">restaurant</Icon>
                        Plato
                      </SoftBox>
                    </MenuItem>
                    <MenuItem value="Plato_Ingrediente">
                      <SoftBox display="flex" alignItems="center" gap={1}>
                        <Icon fontSize="small">inventory_2</Icon>
                        Plato ingrediente
                      </SoftBox>
                    </MenuItem>
                    <MenuItem value="Todo">
                      <SoftBox display="flex" alignItems="center" gap={1}>
                        <Icon fontSize="small">local_dining</Icon>
                        Todo
                      </SoftBox>
                    </MenuItem>
                  </Select>
                </SoftBox>
                <SoftBox
                  mr={{
                    xs: 0,
                    sm: 2,
                  }}
                >
                  <SoftInput
                    placeholder="Escribe aquí..."
                    icon={{ component: "search", direction: "left" }}
                    onChange={handleSearch}
                  />
                </SoftBox>
                <SoftBox mr={2} display={{ xs: "none", sm: "block" }}>
                  <Tooltip title="Stock inicial rápido" placement="top">
                    <SoftButton
                      color="uproGreen"
                      circular
                      iconOnly
                      onClick={() => setOpenModalStockRapido(true)}
                    >
                      <Icon sx={{ fontWeight: "light" }}>electric_bolt</Icon>
                    </SoftButton>
                  </Tooltip>
                </SoftBox>

                <SoftBox mt={2} display={{ xs: "block", sm: "none" }}>
                  <Tooltip title="Stock inicial rápido" placement="top">
                    <SoftButton
                      color="uproGreen"
                      circular
                      fullWidth
                      onClick={() => setOpenModalStockRapido(true)}
                    >
                      <Icon sx={{ fontWeight: "light" }}>electric_bolt</Icon>
                      &nbsp;Stock rápido
                    </SoftButton>
                  </Tooltip>
                </SoftBox>
                <SoftBox
                  mr={2}
                  display={{
                    xs: "none",
                    sm: "block",
                  }}
                >
                  <Tooltip title="Ajustar stock" placement="top">
                    <SoftButton
                      color="uproYellow"
                      onClick={handleOpenAjusteMenu}
                      circular
                      disabled={!selectedSucursal}
                    >
                      <Icon sx={{ fontWeight: "light" }}>drive_file_rename_outline</Icon>
                      &nbsp;Ajustar stock
                    </SoftButton>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>

            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {loading ? (
                <Loading />
              ) : rows?.length > 0 && selectedSucursal ? (
                <DataTable columns={columns} rows={rows} order={orderBy} setOrder={handleOrderBy} />
              ) : (
                <SinDatos />
              )}
            </SoftBox>
            <CustomPagination
              loading={loading}
              length={data?.materiasPrimas.length}
              total={pagesInfo?.total}
              pages={pagesInfo?.pages}
              page={page}
              setPage={setPage}
              noCard
            />
          </Card>
          {renderAjusteMenu}
          {renderAddMenu}
          {renderMenu}
          {renderIngresoMenu}
          {renderSucursalMenu}
        </SoftBox>
      </SoftBox>

      <ModalConfirm
        open={openModalConfirm}
        handleClose={handleCloseModalConfirm}
        message={
          selectedItem?.disabled
            ? `¿Está seguro que desea habilitar la materia prima?`
            : `¿Está seguro que desea deshabilitar la materia prima? ` +
            `No estará disponible para nuevos pedidos y ordenes de compra.`
        }
        func={handleDisabled}
        pedirMotivo={!selectedItem?.disabled}
      />
      <DrawerProductoDetalle
        open={openDetailDrawer}
        handleClose={handleCloseMenu}
        item={selectedItem}
        idSucursal={selectedSucursal}
        idSede={dataSucurales?.sucursales?.find((s) => s.id === selectedSucursal)?.sede.id}
        onEdit={handleOpenProductoModal}
        onToggleEnabled={handleOpenModalConfirm}
      />
      <ModalProducto
        id={selectedItem?.id || null}
        idSucursal={selectedSucursal || null}
        tipo={selectedItem?.tipo || null}
        open={openModalProducto}
        handleClose={() => {
          setOpenModalProducto(false);
        }}
        refetch={() => {
          refetch();
          handleCloseMenu();
          handleCloseAddMenu();
        }}
      />
      <ModalProductoMovimientos
        open={openModalProductoMovimientos}
        handleClose={() => {
          setOpenModalProductoMovimientos(false);
          handleCloseMenu();
        }}
        idProducto={selectedItem?.id}
        idSucursal={selectedSucursal}
      />
      <ModalProductoStock
        open={openModalProductoStock}
        handleClose={() => {
          setOpenModalProductoStock(false);
          handleCloseMenu();
        }}
        idProducto={selectedItem?.id}
        idSede={dataSucurales?.sucursales?.find((s) => s.id === selectedSucursal)?.sede.id}
      />
      <ModalAjuste
        open={openModalAjuste}
        handleClose={() => setOpenModalAjuste(false)}
        selectedAjuste={selectedAjuste}
        idSucursal={selectedSucursal}
        refetchProductos={refetch}
      />
      <ModalAjusteHistory
        open={openModalAjusteHistory}
        handleClose={() => setOpenModalAjusteHistory(false)}
        idSucursal={selectedSucursal}
        refetchProductos={refetch}
      />
      <ModalNuevoRemito
        open={openModalNuevoRemito}
        handleClose={() => {
          setOpenModalNuevoRemito(false);
        }}
        idSucursal={selectedSucursal}
        refetchProductos={refetch}
      />
      <ModalIngresar
        open={openModalIngresar}
        handleClose={() => setOpenModalIngresar(false)}
        idSucursal={selectedSucursal}
        refetchProductos={refetch}
      />
      <ModalOptions
        open={openModalOptions}
        handleClose={() => setOpenModalOptions(false)}
        options={[
          {
            title: "Stock inicial rápido",
            icon: "electric_bolt",
            onClick: () => setOpenModalStockRapido(true),
            color: "uproGreen",
          },
          {
            title: "Ajustar stock",
            icon: "drive_file_rename_outline",
            onClick: (e) => handleOpenAjusteMenu(e),
            color: "uproYellow",
          },
          {
            title: "Ingresar productos",
            icon: "local_shipping",
            onClick: (e) => handleOpenIngresoMenu(e),
            color: "uproYellow",
          },
          // {
          //   title: "Administrar proveedores",
          //   icon: "people_alt",
          //   onClick: () => setOpenModalProveedores(true),
          //   color: "uproYellow",
          // },
          {
            title: "Agregar nueva materia prima",
            icon: "add",
            onClick: (e) => handleOpenAddMenu(e),
            color: "primary",
          },
        ]}
      />
      <ModalStockRapido
        open={openModalStockRapido}
        handleClose={() => setOpenModalStockRapido(false)}
        idSucursal={selectedSucursal}
        refetch={refetch}
      />
      <ModalProveedores
        open={openModalProveedores}
        handleClose={() => setOpenModalProveedores(false)}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default StockPlatos;
